var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-input" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.term,
          expression: "term",
        },
      ],
      staticClass: "answers-input input",
      attrs: {
        type: "text",
        placeholder: "Explore " + (_vm.sitetitle ? _vm.sitetitle : "") + "...",
        tabindex: "-1",
        id: "search",
        autocomplete: "off",
      },
      domProps: { value: _vm.term },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.term = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "search-input-close" }, [
      _c("strong", { staticClass: "type-label" }, [_vm._v("Search types: ")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.type,
              expression: "type",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "searchType", multiple: "multiple" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.type = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _c("option", { attrs: { value: "posts" } }, [_vm._v("Posts")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "events" } }, [_vm._v("Events")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "meetings" } }, [_vm._v("Meetings")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "webinars" } }, [_vm._v("Webinars")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "videos" } }, [_vm._v("Videos")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "jobs" } }, [_vm._v("Jobs")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "products" } }, [_vm._v("Products")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "resources" } }, [
            _vm._v("Resources"),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "suppliers" } }, [
            _vm._v("Suppliers"),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "groups" } }, [_vm._v("Groups")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "users" } }, [_vm._v("Users")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "questions" } }, [
            _vm._v("Questions"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-times" }),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-input-icon" }, [
      _c("i", { staticClass: "fa fa-search fa-2x" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex ml-2" }, [
      _c("ul", {
        staticClass: "search-list",
        attrs: { id: "answers-search-list" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }